import { render, staticRenderFns } from "./HQApprovalDetail.vue?vue&type=template&id=5847d6c7&scoped=true"
import script from "./HQApprovalDetail.vue?vue&type=script&lang=js"
export * from "./HQApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./HQApprovalDetail.vue?vue&type=style&index=0&id=5847d6c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847d6c7",
  null
  
)

export default component.exports